import { createContext } from 'react';

export const RegisteredUserContext = createContext({
  isRegisteredUser: false,
});
